import clsx from 'clsx'
import BaseTitle, {
  TitleProps as BaseTitleProps,
} from 'antd/lib/typography/Title'
import * as styles from './typography.module.css'

export interface TitleProps extends BaseTitleProps {
  space?: 'default' | 'none'
}

export const Title = ({
  className,
  space = 'default',
  ...rest
}: TitleProps): JSX.Element => (
  <>
    <BaseTitle
      {...rest}
      className={clsx(
        className,
        styles.title,
        space === 'none' && styles.title__space_none
      )}
    />
  </>
)
